import { Component, Input, OnInit, DoCheck, ViewEncapsulation } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { StudyViewModel } from '../../viewmodel/study.viewmodel';
import { FYAlignmentMethod, BasePLIVendorAccount } from '../_study_constants';
import { StudyType } from './study-type.model';

@Component({
  selector: 'app-studyinforeadonly',
  templateUrl: './studyInfo_ReadOnly.component.html',
  styleUrls: ['./studyInfo_ReadOnly.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class StudyInfoReadOnlyComponent implements OnInit, DoCheck {
  @Input() studyVM: StudyViewModel = new StudyViewModel();

  displayBenchmarkRegionCountry: TreeNode[];
  fyAlignmentMethod: typeof FYAlignmentMethod = FYAlignmentMethod;
  basePLIVendorAccount: typeof BasePLIVendorAccount = BasePLIVendorAccount;
  studyType = StudyType;

  ngOnInit() {
    this.displayBenchmarkRegionCountry = this.studyVM.displayBenchmarkRegionCountry;
  }

  // During edit mode
  ngDoCheck() {
    if (this.displayBenchmarkRegionCountry.length === 0) {
      this.studyVM.displayBenchmarkRegionCountry.forEach((a) => {
        this.displayBenchmarkRegionCountry.push(a);
      });
    }
  }
}
